import React from "react";

import UIcon from "lib/icons/untitled_ui/UIcon";
import { sysTextSecondary } from "lib/themes/colors";
import { DataTypeNameWithBuyersAndSuppliers } from "lib/types/models";

export function Logo({ url, size = 24 }: { url?: string | null; size?: number }) {
  return url ? (
    <img aria-label="organisation-logo" src={url} height={size} width={size} />
  ) : (
    <UIcon icon="wallet02" color={sysTextSecondary} size={size} />
  );
}

export type Entities = "notice" | "document" | "framework" | "buyer" | "supplier" | "contact";

export const entityToDataType = (entity: Entities): DataTypeNameWithBuyersAndSuppliers => {
  switch (entity) {
    case "notice":
      return "TENDERS|PRE-TENDERS";
    case "document":
      return "DOCUMENTS";
    case "framework":
      return "FRAMEWORKS";
    case "buyer":
      return "BUYERS";
    case "supplier":
      return "SUPPLIERS";
    case "contact":
      return "CONTACTS";
  }
};
